import type { CSSProperties, ReactNode, MouseEvent } from 'react';
import { C } from '../tokens';

export function Card({ children, style, onClick }: { children: ReactNode; style?: CSSProperties; onClick?: (e: MouseEvent<HTMLDivElement>) => void }) {
  return <div onClick={onClick} style={{ background: C.card, border: `1px solid ${C.b}`, borderRadius: 12, padding: 14, ...style }}>{children}</div>;
}
